import { render, staticRenderFns } from "./ZhiYa.vue?vue&type=template&id=19c50b46&scoped=true&"
import script from "./ZhiYa.vue?vue&type=script&lang=js&"
export * from "./ZhiYa.vue?vue&type=script&lang=js&"
import style0 from "./ZhiYa.vue?vue&type=style&index=0&id=19c50b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c50b46",
  null
  
)

export default component.exports